import { render, staticRenderFns } from "./monitoringSetDeleteButton.vue?vue&type=template&id=89a6ab32&scoped=true&"
import script from "./monitoringSetDeleteButton.vue?vue&type=script&lang=js&"
export * from "./monitoringSetDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./monitoringSetDeleteButton.vue?vue&type=style&index=0&id=89a6ab32&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a6ab32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a6ab32')) {
      api.createRecord('89a6ab32', component.options)
    } else {
      api.reload('89a6ab32', component.options)
    }
    module.hot.accept("./monitoringSetDeleteButton.vue?vue&type=template&id=89a6ab32&scoped=true&", function () {
      api.rerender('89a6ab32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/monitoring/monitoringSetDeleteButton.vue"
export default component.exports